import iframeResize from '@iframe-resizer/parent';

import { throttle } from 'throttle-debounce';
import { getCssPropertyValue } from '../../../ts/helper';

/**
 * Friendation component
 * @param component Instance of this _Friendation_ component
 */
const blockEmbedFunction = async (component: HTMLElement) => {
  const handleIframe = () => {
    const iframe = component.querySelector('iframe');
    if (!iframe) return;

    const embedWrapper = <HTMLElement>component.querySelector('.embed');

    let iframeResizerPackageError = false;

    // Try the @iframe-resizer/parent package which some pages use...
    try {
      iframeResize(
        {
          license: 'GPLv3'
        },
        iframe
      );
    } catch (error) {
      iframeResizerPackageError = true;
      console.error(error);
    }

    if (iframeResizerPackageError === false) return;

    /**
     * The `@iframe-resizer/parent` did not work, try to get the native height with JavaScript or at least custom set a minimum height that was defined in the backend.
     */
    const updateHeight = () => {
      let nativeHeightError = false;

      try {
        /**
         * Original iframe height (may be blocked)
         * @example
         *   500
         */
        const nativeHeight =
          iframe?.contentWindow?.document?.documentElement?.scrollHeight;
        if (nativeHeight) iframe.style.height = `${nativeHeight}px`;
      } catch (error) {
        nativeHeightError = true;
        console.error(error);
      }

      if (nativeHeightError === false) return;

      /**
       * Min height
       * @example
       *   "500px"
       */
      const minHeight = getCssPropertyValue('--height', embedWrapper);
      if (minHeight) iframe.style.minHeight = minHeight;
    };

    const onTick = throttle(100, updateHeight.bind(this));

    window.addEventListener('resize', onTick);
    updateHeight();
  };

  handleIframe();
};

/** Selector for any instance of this _Friendation_ component */
const selector = '[is="block-embed"]';

/** Function that handles a single instance of this _Friendation_ component */
const classFunction: (component: HTMLElement) => void = blockEmbedFunction;

/**
 * Friendation component
 */
export const blockEmbed = () => {
  /** Instances of this Friendation component */
  const components: HTMLElement[] = Array.from(
    document.querySelectorAll(selector)
  );

  components.forEach((x) => {
    classFunction.call(this, x);
  });
};
